// extracted by mini-css-extract-plugin
export default {"flex":"Flex_flex__KFQty","flexRow":"Flex_flexRow__jNYOK","flexColumn":"Flex_flexColumn__-bXy6"};